package com.vamvisions.main.portfolio.presentation.projects

import com.vamvisions.main.core.domain.preferences.Language

sealed interface ProjectsAction {
    data object Retry : ProjectsAction
    data class LanguageChanged(val language: Language) : ProjectsAction
}
